// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3me7O","clinicsSelect":"styles_clinicsSelect__3gp5G"};